import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { ActiveCallOverlayState } from './active-call-overlay.models';
import { DialogService } from '../../services/dialog.service';
import { ActiveCallOverlayService } from '../../services/active-call-overlay.service';
import { LocalizationService } from '../../services/localization.service';

@Component({
  selector: 'app-active-call-overlay',
  templateUrl: './active-call-overlay.component.html',
  styleUrls: ['./active-call-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActiveCallOverlayComponent implements OnInit, OnDestroy {
  public readonly maxNoteLength = 800;
  public readonly noteControl = new FormControl('', [Validators.maxLength(this.maxNoteLength)]);
  public readonly state$: Observable<ActiveCallOverlayState> = this.activeCallOverlayService.state$;

  private readonly subscription$ = new Subscription();

  constructor(
    private activeCallOverlayService: ActiveCallOverlayService,
    private dialogService: DialogService,
    private ls: LocalizationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscription$.add(
      this.state$.subscribe((state) => {
        const note = state.data?.note ?? '';
        if (note !== this.noteControl.value) {
          this.noteControl.setValue(note, { emitEvent: false });
        }
        this.cdr.markForCheck();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  public onSave(): void {
    if (this.noteControl.invalid) return;

    this.activeCallOverlayService.requestSave(this.noteControl.value ?? '');
  }

  public onClose(): void {
    this.subscription$.add(
      this.dialogService
        .openConfirmationDialog({
          text: this.ls.translate('guard.closeOverlay'),
          acceptKey: 'button.close',
          cancelKey: 'button.cancel'
        })
        .subscribe((shouldClose) => {
          if (shouldClose) this.activeCallOverlayService.close('user');
        })
    );
  }

  public get noteLength(): number {
    return this.noteControl.value?.length ?? 0;
  }
}
